import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmailIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 4L5.08246 6.85772C5.41304 7.08913 5.57834 7.20484 5.75813 7.24965C5.91695 7.28924 6.08305 7.28924 6.24187 7.24965C6.42166 7.20484 6.58695 7.08913 6.91754 6.85772L11 4M3.4 10.5H8.6C9.44008 10.5 9.86012 10.5 10.181 10.3365C10.4632 10.1927 10.6927 9.96323 10.8365 9.68099C11 9.36012 11 8.94008 11 8.1V4.9C11 4.05992 11 3.63988 10.8365 3.31901C10.6927 3.03677 10.4632 2.8073 10.181 2.66349C9.86012 2.5 9.44008 2.5 8.6 2.5H3.4C2.55992 2.5 2.13988 2.5 1.81901 2.66349C1.53677 2.8073 1.3073 3.03677 1.16349 3.31901C1 3.63988 1 4.05992 1 4.9V8.1C1 8.94008 1 9.36012 1.16349 9.68099C1.3073 9.96323 1.53677 10.1927 1.81901 10.3365C2.13988 10.5 2.55992 10.5 3.4 10.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEmailIcon;
